const updateTeamStatsSeason = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'teamComparison') {
        const { away, home, teamComparisonGameType } = action?.data?.data || {};

        return Object.assign({}, state, {
            away,
            home,
            teamComparisonGameType
        });
    }

    return state;
};

export default updateTeamStatsSeason;
